import { ProgramEngagementRecommendationsAPI, RecommendedPracticesResponse } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'

export const RECOMMENDED_PRACTICES_QUERY_KEY = 'recommendedPractices'

export const useRecommendedFieldPractices = (engagementId?: string) => {
  return useQuery<RecommendedPracticesResponse | undefined>({
    queryKey: [RECOMMENDED_PRACTICES_QUERY_KEY, engagementId],
    queryFn: async () => {
      if (!engagementId) {
        return undefined
      }
      const goals = await ProgramEngagementRecommendationsAPI.goals(engagementId)
      return goals
    },
  })
}
